import config from "../../config";

const isProduction = () => process.env.NODE_ENV === "production" && config.NODE_ENV === "production";

export const logger = {
    log: (...args: unknown[]) => {
        if (!isProduction()) console.log(...args);
    },
    warn: (...args: unknown[]) => {
        if (!isProduction()) console.warn(...args);
    },
    error: (...args: unknown[]) => {
        if (!isProduction()) console.error(...args);
    },
    debug: (...args: unknown[]) => {
        if (!isProduction()) console.debug(...args);
    }
};
